import React from 'react';
import { useTranslation } from 'react-i18next';
import { MyProductReservations } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { FiltersProvider } from '@context';

export function MyProductReservationsPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('my-product-reservations-component.metatags.title'),
        description: t('my-product-reservations-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myProductReservations,
        index: false,
    });

    return (
        <FiltersProvider>
            <MyProductReservations />
        </FiltersProvider>
    );
}
